import React from 'react'
// @ts-ignore no types
import { connect } from 'react-redux'
// @ts-ignore no types
import { partition, invertBy, sortBy } from 'lodash'
import type { PDPDisplayedDocumentsType } from '@adc/blueprint/lib/listing/pdp/types'
import { useListingContext } from 'common/context/listing'
// @ts-ignore no types
import { hooks } from '@adc/ui-adc'
import instrument from '@adc/instrument'
import _cx from 'classnames/bind'
import analytics from '../../services/analytics'
import SectionPanel from '../../components/sectionPanel'
import MobileViewDocuments from './mobileViewDocuments'
import DesktopViewDocuments from './desktopViewDocuments'

const AdditionalDocumentsSection = () => {
  const isMobile = hooks.useIsMobileHook()
  const { listing } = useListingContext()
  const { applicableDocuments } = listing.__computed__

  const viewDocument = (
    document: PDPDisplayedDocumentsType,
    embeddedContext = 'browser'
  ) => {
    analytics.documents(document)
    instrument.increment('pdp_document_click', 1, [`type:${document.type}`])
    const redirectUrl = document.url
    if (redirectUrl) {
      window.open(
        redirectUrl,
        embeddedContext === 'webview' ? '_self' : '_blank'
      )
    }
  }

  const renderDocuments = (documents: PDPDisplayedDocumentsType[] = []) => {
    if (documents.length === 0) return null
    if (isMobile) {
      return (
        <MobileViewDocuments
          documents={documents}
          elmId='document_section_doc'
          viewDocument={viewDocument}
        />
      )
    }
    return (
      <DesktopViewDocuments documents={documents} viewDocument={viewDocument} />
    )
  }

  return applicableDocuments?.length > 0 ? (
    <SectionPanel
      elmId='documents'
      title='Additional Documents'
      compact='top-only'
    >
      {renderDocuments(applicableDocuments)}
    </SectionPanel>
  ) : null
}

export default AdditionalDocumentsSection
